import { shell } from '../../shell/shellClasses';
import { BlockCsvButton } from '../debug-export/BlockCsvButton';
import { dailyBriefCalcCsv } from '../debug-export/blockCsv';
import { downloadCsv } from '../debug-export/csv';
import { HealthCards } from './HealthCards';
import { MetricBlock } from './MetricBlock';
import type { DailyBriefModel } from './types';

export function DailyBriefPanel({
  model,
  loading,
  error,
  onRetry,
}: {
  model: DailyBriefModel | null;
  loading: boolean;
  error: string | null;
  onRetry: () => void;
}) {
  return (
    <section
      id="widget-daily-brief"
      data-widget-id="daily-brief"
      aria-label="Business health and yesterday"
      className="space-y-8"
    >
      {error && (
        <div
          role="alert"
          className="rounded-[var(--shell-radius-md)] bg-[var(--shell-danger)]/10 px-4 py-3 text-sm text-[var(--shell-danger)]"
        >
          {error}{' '}
          <button type="button" className="underline" onClick={onRetry}>
            Try again
          </button>
        </div>
      )}

      {loading && !model ? (
        <div className="space-y-6" aria-busy="true" aria-label="Loading business health">
          <div className="h-20 w-64 animate-pulse rounded-[var(--shell-radius-md)] bg-[var(--shell-hover)] motion-reduce:animate-none" />
          <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="h-24 animate-pulse rounded-[var(--shell-radius-md)] bg-[var(--shell-hover)] motion-reduce:animate-none"
              />
            ))}
          </div>
        </div>
      ) : model ? (
        <>
          <HealthCards health={model.health} />

          <div>
            <div className="mb-3 flex flex-wrap items-baseline justify-between gap-3">
              <h2 className="text-sm font-semibold text-[var(--shell-fg)]">
                Yesterday
                <span className={`ml-2 font-normal ${shell.muted}`}>
                  {model.yesterdayLabel} vs {model.priorLabel}
                </span>
              </h2>
              <BlockCsvButton
                onClick={() => {
                  downloadCsv('dashboard_daily-brief.csv', dailyBriefCalcCsv(model));
                }}
              />
            </div>
            <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
              {model.metrics.map((m) => (
                <MetricBlock key={m.id} metric={m} />
              ))}
            </div>
          </div>

        </>
      ) : null}
    </section>
  );
}
